import { render, staticRenderFns } from "./ResearchSection.vue?vue&type=template&id=7d9f4d92"
import script from "./ResearchSection.vue?vue&type=script&lang=js"
export * from "./ResearchSection.vue?vue&type=script&lang=js"
import style0 from "./ResearchSection.vue?vue&type=style&index=0&id=7d9f4d92&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9f4d92')) {
      api.createRecord('7d9f4d92', component.options)
    } else {
      api.reload('7d9f4d92', component.options)
    }
    module.hot.accept("./ResearchSection.vue?vue&type=template&id=7d9f4d92", function () {
      api.rerender('7d9f4d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSection.vue"
export default component.exports